export const sdgCourses = [
  {
    id: 1,
    title: "No Poverty",
    icon: "🏠",
    color: "#E5243B",
    description: "End poverty in all its forms everywhere",
    modules: [
      {
        title: "Understanding Poverty in Africa",
        content: `
          <h2>Understanding Poverty in African Contexts</h2>
          
          <h3>What is Poverty?</h3>
          <p>Poverty is more than just lacking money. In Africa, poverty means:</p>
          <ul>
            <li>Limited access to education and healthcare</li>
            <li>Food insecurity and malnutrition</li>
            <li>Poor housing conditions</li>
            <li>Limited economic opportunities</li>
            <li>Social exclusion and discrimination</li>
          </ul>

          <h3>Poverty Statistics in Africa</h3>
          <p>Current situation across the continent:</p>
          <ul>
            <li>Over 400 million people live in extreme poverty</li>
            <li>Poverty rates vary from 10% to 70% across countries</li>
            <li>Rural areas are disproportionately affected</li>
            <li>Women and children are most vulnerable</li>
          </ul>

          <h3>African Solutions to Poverty</h3>
          <p>Traditional and modern approaches:</p>
          <ul>
            <li><strong>Community Savings Groups:</strong> Traditional systems like "esusu" in West Africa</li>
            <li><strong>Agricultural Cooperatives:</strong> Collective farming for better market access</li>
            <li><strong>Microfinance:</strong> Small loans for entrepreneurs</li>
            <li><strong>Digital Payments:</strong> Mobile money reducing transaction costs</li>
          </ul>

          <h3>Case Study: Ghana's Poverty Reduction</h3>
          <p>Ghana reduced poverty from 52% to 21% between 1991 and 2012 through:</p>
          <ul>
            <li>Investment in education and healthcare</li>
            <li>Agricultural modernization</li>
            <li>Social protection programs</li>
            <li>Economic diversification</li>
          </ul>

          <h3>Your Role in Ending Poverty</h3>
          <p>As an African girl, you can contribute by:</p>
          <ul>
            <li>Supporting local businesses</li>
            <li>Educating others about financial literacy</li>
            <li>Advocating for equal opportunities</li>
            <li>Creating community projects</li>
          </ul>
        `,
        duration: "45 minutes"
      },
      {
        title: "Economic Empowerment Strategies",
        content: `
          <h2>Economic Empowerment for Poverty Reduction</h2>
          
          <h3>Understanding Economic Empowerment</h3>
          <p>Economic empowerment means having the ability to make and act on economic decisions. Key elements include:</p>
          <ul>
            <li>Access to financial services</li>
            <li>Skills development and education</li>
            <li>Property and inheritance rights</li>
            <li>Participation in economic decision-making</li>
          </ul>

          <h3>Successful African Initiatives</h3>
          <p>Examples from across the continent:</p>
          <ul>
            <li><strong>Kenya:</strong> Women's enterprise funds</li>
            <li><strong>Rwanda:</strong> Land rights reforms</li>
            <li><strong>Nigeria:</strong> Youth entrepreneurship programs</li>
            <li><strong>South Africa:</strong> Broad-Based Black Economic Empowerment</li>
          </ul>

          <h3>Financial Literacy for Girls</h3>
          <p>Essential skills for economic independence:</p>
          <ul>
            <li>Budgeting and saving</li>
            <li>Understanding credit and loans</li>
            <li>Basic business management</li>
            <li>Digital financial skills</li>
          </ul>
        `,
        duration: "40 minutes"
      }
    ],
    quiz: [
      {
        question: "What does extreme poverty mean according to the World Bank?",
        options: [
          "Living on less than $1.90 per day",
          "Living without electricity",
          "Not having access to education",
          "Living in rural areas"
        ],
        correctAnswer: 0,
        explanation: "The World Bank defines extreme poverty as living on less than $1.90 per day, adjusted for purchasing power parity."
      },
      {
        question: "Which African country successfully reduced poverty from 52% to 21% between 1991 and 2012?",
        options: [
          "Ghana",
          "Nigeria",
          "Kenya",
          "South Africa"
        ],
        correctAnswer: 0,
        explanation: "Ghana achieved this remarkable poverty reduction through investments in education, healthcare, and economic diversification."
      },
      {
        question: "What traditional savings system is commonly used in West Africa to combat poverty?",
        options: [
          "Esusu or rotating savings",
          "Mobile banking",
          "Stock market investing",
          "Cryptocurrency"
        ],
        correctAnswer: 0,
        explanation: "Esusu is a traditional rotating savings and credit association common in West Africa where members contribute regularly and take turns receiving the total contributions."
      },
      {
        question: "Which group is most vulnerable to poverty in Africa according to the module?",
        options: [
          "Women and children",
          "Urban youth",
          "Elderly men",
          "Government workers"
        ],
        correctAnswer: 0,
        explanation: "Women and children are disproportionately affected by poverty due to factors like limited education access, discrimination, and caregiving responsibilities."
      },
      {
        question: "What is a key characteristic of multidimensional poverty?",
        options: [
          "It includes lack of education, healthcare, and living standards",
          "It only measures income levels",
          "It focuses only on urban poverty",
          "It excludes rural communities"
        ],
        correctAnswer: 0,
        explanation: "Multidimensional poverty considers various deprivations including education, health, and living standards, not just income."
      },
      {
        question: "Which of these is NOT mentioned as an African solution to poverty?",
        options: [
          "Importing foreign goods",
          "Community savings groups",
          "Agricultural cooperatives",
          "Digital payments"
        ],
        correctAnswer: 0,
        explanation: "The module emphasizes local solutions like community savings, cooperatives, and digital payments rather than importing foreign goods."
      },
      {
        question: "What percentage of Africa's population lives in extreme poverty?",
        options: [
          "Over 400 million people",
          "100 million people",
          "50 million people",
          "Under 10 million people"
        ],
        correctAnswer: 0,
        explanation: "The module states that over 400 million people in Africa live in extreme poverty, highlighting the scale of the challenge."
      },
      {
        question: "What role can African girls play in ending poverty according to the module?",
        options: [
          "All of the above",
          "Support local businesses",
          "Educate others about financial literacy",
          "Create community projects"
        ],
        correctAnswer: 0,
        explanation: "The module emphasizes that African girls can contribute in multiple ways including supporting local businesses, financial education, and community projects."
      },
      {
        question: "Which factor contributes significantly to rural poverty in Africa?",
        options: [
          "Limited access to markets and infrastructure",
          "Too many job opportunities",
          "Excessive government support",
          "Over-education"
        ],
        correctAnswer: 0,
        explanation: "Limited access to markets, infrastructure, and services are key factors contributing to rural poverty in Africa."
      },
      {
        question: "What is economic empowerment?",
        options: [
          "Ability to make and act on economic decisions",
          "Having a university degree",
          "Working for the government",
          "Owning a car"
        ],
        correctAnswer: 0,
        explanation: "Economic empowerment involves having the capability and freedom to make economic decisions and act on them effectively."
      },
      {
        question: "Which country implemented successful land rights reforms mentioned in the module?",
        options: [
          "Rwanda",
          "Egypt",
          "Morocco",
          "Angola"
        ],
        correctAnswer: 0,
        explanation: "Rwanda's land rights reforms have been recognized as successful in promoting economic empowerment and reducing poverty."
      },
      {
        question: "What is the main purpose of microfinance in poverty reduction?",
        options: [
          "Provide small loans to entrepreneurs",
          "Give free money to the poor",
          "Replace traditional banking",
          "Support large corporations"
        ],
        correctAnswer: 0,
        explanation: "Microfinance provides small loans and financial services to entrepreneurs and small businesses who lack access to traditional banking."
      },
      {
        question: "Which of these is a key feature of agricultural cooperatives?",
        options: [
          "Collective farming for better market access",
          "Individual farming with no coordination",
          "Government-controlled farming",
          "Foreign-owned farms"
        ],
        correctAnswer: 0,
        explanation: "Agricultural cooperatives involve farmers working together to achieve better market access, bargaining power, and resource sharing."
      },
      {
        question: "How does mobile money help reduce poverty?",
        options: [
          "Reduces transaction costs and increases financial inclusion",
          "Makes banking more expensive",
          "Only benefits urban populations",
          "Replaces traditional savings methods completely"
        ],
        correctAnswer: 0,
        explanation: "Mobile money reduces transaction costs, increases financial inclusion, and provides access to financial services for underserved populations."
      },
      {
        question: "What is social protection in the context of poverty reduction?",
        options: [
          "Programs that prevent and reduce poverty",
          "Military protection for communities",
          "Private security services",
          "International aid only"
        ],
        correctAnswer: 0,
        explanation: "Social protection includes programs like cash transfers, food assistance, and health insurance that prevent and reduce poverty and vulnerability."
      },
      {
        question: "Which factor makes women particularly vulnerable to poverty?",
        options: [
          "Limited access to education and property rights",
          "Too much education",
          "Excessive property ownership",
          "Over-representation in government"
        ],
        correctAnswer: 0,
        explanation: "Women often face barriers to education, property ownership, and economic opportunities, making them more vulnerable to poverty."
      },
      {
        question: "What is the relationship between education and poverty?",
        options: [
          "Education helps break the cycle of poverty",
          "Education has no impact on poverty",
          "Education increases poverty",
          "Only university education matters for poverty reduction"
        ],
        correctAnswer: 0,
        explanation: "Education provides skills, knowledge, and opportunities that help individuals and communities escape and prevent poverty."
      },
      {
        question: "Which African initiative focuses on youth entrepreneurship?",
        options: [
          "Nigeria's youth entrepreneurship programs",
          "South Africa's mining programs",
          "Egypt's tourism programs",
          "Morocco's fishing programs"
        ],
        correctAnswer: 0,
        explanation: "Nigeria has implemented various youth entrepreneurship programs to address unemployment and poverty among young people."
      },
      {
        question: "What is the significance of community-based approaches to poverty reduction?",
        options: [
          "They are culturally appropriate and sustainable",
          "They are always expensive",
          "They require foreign experts",
          "They only work in urban areas"
        ],
        correctAnswer: 0,
        explanation: "Community-based approaches are often more sustainable and culturally appropriate as they involve local knowledge and participation."
      },
      {
        question: "How can digital skills help in poverty reduction?",
        options: [
          "Create new economic opportunities and access to information",
          "Only benefit IT professionals",
          "Make traditional skills obsolete",
          "Are only relevant in developed countries"
        ],
        correctAnswer: 0,
        explanation: "Digital skills open up new economic opportunities, improve access to information and services, and can be leveraged for entrepreneurship and employment."
      }
    ]
  },
  {
    id: 2,
    title: "Zero Hunger",
    icon: "🍽️",
    color: "#DDA63A",
    description: "End hunger, achieve food security and improved nutrition",
    modules: [
      {
        title: "Food Security in Africa",
        content: `
          <h2>Achieving Food Security in Africa</h2>
          
          <h3>Understanding Hunger and Food Security</h3>
          <p>Food security exists when all people, at all times, have physical and economic access to sufficient, safe and nutritious food.</p>
          
          <h3>Current Situation in Africa</h3>
          <ul>
            <li>256 million people in Africa are undernourished</li>
            <li>Climate change affects agricultural production</li>
            <li>Post-harvest losses account for 30-40% of food produced</li>
            <li>Women produce 60-80% of food but own only 15% of land</li>
          </ul>

          <h3>Traditional African Food Systems</h3>
          <p>Indigenous knowledge and practices:</p>
          <ul>
            <li><strong>Intercropping:</strong> Growing multiple crops together</li>
            <li><strong>Terracing:</strong> Soil conservation in hilly areas</li>
            <li><strong>Seed Saving:</strong> Preserving indigenous seeds</li>
            <li><strong>Food Preservation:</strong> Traditional drying and storage methods</li>
          </ul>

          <h3>Innovative Solutions</h3>
          <ul>
            <li><strong>Climate-Smart Agriculture:</strong> Drought-resistant crops</li>
            <li><strong>Urban Farming:</strong> Rooftop and vertical gardens</li>
            <li><strong>Digital Agriculture:</strong> Mobile apps for farmers</li>
            <li><strong>Biofortification:</strong> Nutrient-enhanced crops</li>
          </ul>

          <h3>Case Study: Ethiopia's Productive Safety Net Program</h3>
          <p>This program provides food and cash transfers to food-insecure households while building community assets.</p>
        `,
        duration: "50 minutes"
      },
      {
        title: "Nutrition and Sustainable Agriculture",
        content: `
          <h2>Nutrition and Sustainable Food Systems</h2>
          
          <h3>Nutrition Challenges in Africa</h3>
          <ul>
            <li>Micronutrient deficiencies affect 40% of children</li>
            <li>Double burden of malnutrition: undernutrition and obesity</li>
            <li>Limited dietary diversity</li>
            <li>Cultural beliefs affecting food choices</li>
          </ul>

          <h3>Traditional African Superfoods</h3>
          <p>Nutrient-rich indigenous foods:</p>
          <ul>
            <li><strong>Moringa:</strong> High in vitamins and minerals</li>
            <li><strong>Fonio:</strong> Ancient grain rich in amino acids</li>
            <li><strong>Baobab:</strong> High in vitamin C and antioxidants</li>
            <li><strong>African Leafy Vegetables:</strong> Nutrient-dense traditional greens</li>
          </ul>

          <h3>Sustainable Farming Practices</h3>
          <ul>
            <li>Agroforestry: Integrating trees with crops</li>
            <li>Conservation agriculture: Minimal soil disturbance</li>
            <li>Integrated pest management</li>
            <li>Water harvesting techniques</li>
          </ul>
        `,
        duration: "45 minutes"
      }
    ],
    quiz: [
      {
        question: "How many people in Africa are undernourished according to the module?",
        options: [
          "256 million",
          "100 million",
          "50 million",
          "500 million"
        ],
        correctAnswer: 0,
        explanation: "The module states that 256 million people in Africa suffer from undernourishment, highlighting the scale of hunger on the continent."
      },
      {
        question: "What percentage of food is lost to post-harvest losses in Africa?",
        options: [
          "30-40%",
          "10-15%",
          "5-10%",
          "50-60%"
        ],
        correctAnswer: 0,
        explanation: "Post-harvest losses account for 30-40% of food produced in Africa, representing a significant challenge to food security."
      },
      {
        question: "What percentage of food in Africa is produced by women?",
        options: [
          "60-80%",
          "20-30%",
          "40-50%",
          "10-20%"
        ],
        correctAnswer: 0,
        explanation: "Women play a crucial role in African agriculture, producing 60-80% of food despite facing significant barriers."
      },
      {
        question: "Which traditional practice involves growing multiple crops together?",
        options: [
          "Intercropping",
          "Monocropping",
          "Hydroponics",
          "Terracing"
        ],
        correctAnswer: 0,
        explanation: "Intercropping is a traditional African practice of growing multiple crops together to maximize land use and reduce pest damage."
      },
      {
        question: "What is climate-smart agriculture?",
        options: [
          "Farming methods adapted to climate change",
          "Farming only during rainy seasons",
          "Using only traditional methods",
          "Farming without technology"
        ],
        correctAnswer: 0,
        explanation: "Climate-smart agriculture involves practices that increase productivity, enhance resilience, and reduce greenhouse gas emissions."
      },
      {
        question: "Which innovative solution involves growing food in cities?",
        options: [
          "Urban farming",
          "Large-scale monoculture",
          "Traditional pastoralism",
          "Export-focused agriculture"
        ],
        correctAnswer: 0,
        explanation: "Urban farming includes rooftop gardens, vertical farming, and other methods of growing food in urban areas to improve food access."
      },
      {
        question: "What is biofortification?",
        options: [
          "Enhancing nutrient content in crops",
          "Using chemical fertilizers only",
          "Growing genetically modified organisms",
          "Importing fortified foods"
        ],
        correctAnswer: 0,
        explanation: "Biofortification involves breeding crops to increase their nutritional value, addressing micronutrient deficiencies."
      },
      {
        question: "Which traditional method helps conserve soil in hilly areas?",
        options: [
          "Terracing",
          "Intercropping",
          "Seed saving",
          "Crop rotation"
        ],
        correctAnswer: 0,
        explanation: "Terracing creates flat areas on slopes to reduce soil erosion and conserve water in hilly regions."
      },
      {
        question: "What percentage of land in Africa is owned by women?",
        options: [
          "15%",
          "50%",
          "30%",
          "70%"
        ],
        correctAnswer: 0,
        explanation: "Despite producing most of the food, women own only about 15% of agricultural land in Africa, limiting their economic empowerment."
      },
      {
        question: "Which digital tool is mentioned for helping farmers?",
        options: [
          "Mobile apps",
          "Satellite television",
          "Radio only",
          "Printed newspapers"
        ],
        correctAnswer: 0,
        explanation: "Mobile applications provide farmers with weather information, market prices, and agricultural advice, improving decision-making."
      },
      {
        question: "What is food security?",
        options: [
          "Access to sufficient, safe, nutritious food",
          "Having large food storage",
          "Exporting food to other countries",
          "Eating three meals daily"
        ],
        correctAnswer: 0,
        explanation: "Food security means all people have physical and economic access to sufficient, safe, and nutritious food at all times."
      },
      {
        question: "Which factor significantly affects African agriculture?",
        options: [
          "Climate change",
          "Too much rainfall",
          "Lack of traditional knowledge",
          "Over-mechanization"
        ],
        correctAnswer: 0,
        explanation: "Climate change brings unpredictable weather patterns, droughts, and floods that significantly impact agricultural production in Africa."
      },
      {
        question: "What is the main goal of seed saving traditions?",
        options: [
          "Preserve indigenous crop varieties",
          "Reduce farming costs",
          "Increase crop yields immediately",
          "Replace modern seeds"
        ],
        correctAnswer: 0,
        explanation: "Seed saving preserves indigenous crop varieties that are adapted to local conditions and maintain biodiversity."
      },
      {
        question: "Which practice helps reduce post-harvest losses?",
        options: [
          "Improved storage methods",
          "Increasing production",
          "Exporting more food",
          "Reducing planting areas"
        ],
        correctAnswer: 0,
        explanation: "Improved storage techniques like hermetic bags and solar dryers can significantly reduce post-harvest losses."
      },
      {
        question: "What role do women play in African food systems?",
        options: [
          "Primary food producers and processors",
          "Only consumers of food",
          "Mainly involved in food export",
          "Focused only on cooking"
        ],
        correctAnswer: 0,
        explanation: "Women are central to African food systems as producers, processors, and marketers of food, despite facing numerous challenges."
      },
      {
        question: "Which innovation addresses micronutrient deficiencies?",
        options: [
          "Biofortified crops",
          "Food imports",
          "Chemical additives",
          "Processed foods only"
        ],
        correctAnswer: 0,
        explanation: "Biofortified crops like vitamin A-enriched sweet potatoes help address specific nutrient deficiencies in local diets."
      },
      {
        question: "What is urban farming's main advantage?",
        options: [
          "Reduces food transportation costs",
          "Uses more water than rural farming",
          "Requires large land areas",
          "Is only for ornamental plants"
        ],
        correctAnswer: 0,
        explanation: "Urban farming reduces the distance food travels from farm to table, lowering transportation costs and improving freshness."
      },
      {
        question: "How does intercropping benefit farmers?",
        options: [
          "Improves soil fertility and reduces pests",
          "Increases water usage",
          "Requires more chemicals",
          "Makes harvesting difficult"
        ],
        correctAnswer: 0,
        explanation: "Intercropping can improve soil health, reduce pest damage, and provide more diverse harvests from the same land."
      },
      {
        question: "What challenge does climate change pose to African agriculture?",
        options: [
          "Unpredictable weather patterns",
          "Too much government support",
          "Over-production of food",
          "Lack of traditional knowledge"
        ],
        correctAnswer: 0,
        explanation: "Climate change brings unpredictable rainfall, higher temperatures, and extreme weather events that challenge traditional farming practices."
      },
      {
        question: "Why is preserving indigenous knowledge important for food security?",
        options: [
          "It contains sustainable adaptation strategies",
          "It is always more productive",
          "It requires no innovation",
          "It replaces modern science"
        ],
        correctAnswer: 0,
        explanation: "Indigenous knowledge includes time-tested strategies for coping with local environmental conditions and maintaining biodiversity."
      }
    ]
  },
  {
    id: 3,
    title: "Good Health & Well-being",
    icon: "❤️",
    color: "#4C9F38",
    description: "Ensure healthy lives and promote well-being for all at all ages",
    modules: [
      {
        title: "Healthcare Challenges in Africa",
        content: `
          <h2>Healthcare and Well-being in Africa</h2>
          
          <h3>Major Health Challenges</h3>
          <ul>
            <li>High maternal and child mortality rates</li>
            <li>Infectious diseases: Malaria, HIV/AIDS, Tuberculosis</li>
            <li>Rising non-communicable diseases: Diabetes, hypertension</li>
            <li>Limited access to healthcare facilities</li>
            <li>Shortage of healthcare workers</li>
          </ul>

          <h3>Traditional African Medicine</h3>
          <p>Indigenous healing practices:</p>
          <ul>
            <li>Use of medicinal plants and herbs</li>
            <li>Spiritual and holistic approaches to healing</li>
            <li>Community-based care systems</li>
            <li>Preventive health practices</li>
          </ul>

          <h3>Innovative Healthcare Solutions</h3>
          <ul>
            <li><strong>Mobile Health Clinics:</strong> Reaching remote areas</li>
            <li><strong>Telemedicine:</strong> Remote consultations</li>
            <li><strong>Community Health Workers:</strong> Local healthcare providers</li>
            <li><strong>Health Insurance Schemes:</strong> Making care affordable</li>
          </ul>

          <h3>Mental Health Awareness</h3>
          <p>Addressing the stigma and providing support:</p>
          <ul>
            <li>Community support systems</li>
            <li>Traditional healing approaches</li>
            <li>Integration with modern medicine</li>
            <li>Youth mental health programs</li>
          </ul>

          <h3>Case Study: Rwanda's Community-Based Health Insurance</h3>
          <p>Rwanda achieved 90% health insurance coverage through community-based Mutuelle de Santé system.</p>
        `,
        duration: "55 minutes"
      },
      {
        title: "Preventive Healthcare and Wellness",
        content: `
          <h2>Preventive Healthcare and Community Wellness</h2>
          
          <h3>Importance of Preventive Care</h3>
          <ul>
            <li>Vaccination programs</li>
            <li>Regular health screenings</li>
            <li>Nutrition education</li>
            <li>Hygiene and sanitation practices</li>
          </ul>

          <h3>Traditional Preventive Practices</h3>
          <ul>
            <li>Herbal remedies for common ailments</li>
            <li>Dietary practices for seasonal health</li>
            <li>Physical activity traditions</li>
            <li>Community health rituals</li>
          </ul>

          <h3>Women's Health Empowerment</h3>
          <ul>
            <li>Maternal health education</li>
            <li>Reproductive health services</li>
            <li>Nutrition for women and girls</li>
            <li>Mental health support</li>
          </ul>
        `,
        duration: "50 minutes"
      }
    ],
    quiz: [
      {
        question: "What are the major infectious diseases affecting Africa mentioned in the module?",
        options: [
          "Malaria, HIV/AIDS, Tuberculosis",
          "COVID-19 only",
          "Diabetes and hypertension",
          "Heart disease and cancer"
        ],
        correctAnswer: 0,
        explanation: "Malaria, HIV/AIDS, and Tuberculosis remain significant infectious disease challenges in Africa alongside emerging health issues."
      },
      {
        question: "What is a key feature of traditional African medicine?",
        options: [
          "Holistic approach to healing",
          "Reliance on imported medicines",
          "Focus only on physical symptoms",
          "Rejection of community involvement"
        ],
        correctAnswer: 0,
        explanation: "Traditional African medicine typically takes a holistic approach, considering physical, spiritual, and community aspects of health."
      },
      {
        question: "Which innovative solution helps reach remote communities with healthcare?",
        options: [
          "Mobile health clinics",
          "Large central hospitals",
          "International medical tourism",
          "Private clinics only"
        ],
        correctAnswer: 0,
        explanation: "Mobile health clinics bring essential healthcare services to remote and underserved communities across Africa."
      },
      {
        question: "What is telemedicine?",
        options: [
          "Remote medical consultations using technology",
          "Traditional healing methods",
          "Importing foreign doctors",
          "Self-medication practices"
        ],
        correctAnswer: 0,
        explanation: "Telemedicine uses technology like phones and computers to provide medical consultations and support remotely."
      },
      {
        question: "Who are community health workers?",
        options: [
          "Local trained healthcare providers",
          "International medical volunteers",
          "Government health ministers",
          "Hospital administrators"
        ],
        correctAnswer: 0,
        explanation: "Community health workers are local individuals trained to provide basic healthcare and health education in their communities."
      },
      {
        question: "What is a major challenge in African healthcare mentioned in the module?",
        options: [
          "Shortage of healthcare workers",
          "Too many hospitals",
          "Excess medical supplies",
          "Over-qualified doctors"
        ],
        correctAnswer: 0,
        explanation: "Many African countries face a critical shortage of healthcare workers, particularly in rural areas."
      },
      {
        question: "How does traditional medicine view health?",
        options: [
          "As balance between physical and spiritual",
          "As absence of disease only",
          "As purely biological",
          "As individual responsibility only"
        ],
        correctAnswer: 0,
        explanation: "Traditional African medicine often views health as a balance between physical, spiritual, and social well-being."
      },
      {
        question: "What are rising health concerns in Africa?",
        options: [
          "Non-communicable diseases like diabetes",
          "Only infectious diseases",
          "Seasonal allergies",
          "Vitamin deficiencies only"
        ],
        correctAnswer: 0,
        explanation: "Non-communicable diseases such as diabetes, hypertension, and cancer are becoming increasingly prevalent in Africa."
      },
      {
        question: "What role do medicinal plants play in African healthcare?",
        options: [
          "Source of traditional remedies",
          "Primary export products",
          "Ornamental purposes only",
          "Replacement for all modern medicine"
        ],
        correctAnswer: 0,
        explanation: "Medicinal plants have been used for centuries in African traditional medicine and continue to be important healthcare resources."
      },
      {
        question: "How can health insurance schemes help?",
        options: [
          "Make healthcare more affordable",
          "Increase treatment costs",
          "Limit access to care",
          "Replace government services"
        ],
        correctAnswer: 0,
        explanation: "Health insurance schemes help make healthcare more affordable and accessible, particularly for low-income populations."
      },
      {
        question: "What is a community-based care system?",
        options: [
          "Healthcare involving family and community support",
          "Hospital-only care",
          "International medical care",
          "Private individual care"
        ],
        correctAnswer: 0,
        explanation: "Community-based care involves families and communities in providing support and care for individuals, particularly for chronic conditions."
      },
      {
        question: "Why is mental health important to address?",
        options: [
          "It affects overall well-being and productivity",
          "It only affects a few people",
          "It is not related to physical health",
          "It is easily treated with medication alone"
        ],
        correctAnswer: 0,
        explanation: "Mental health is crucial for overall well-being, affects physical health, and impacts community productivity and development."
      },
      {
        question: "What is preventive health care?",
        options: [
          "Actions to prevent diseases before they occur",
          "Treating diseases after they appear",
          "Emergency medical services",
          "Surgical procedures only"
        ],
        correctAnswer: 0,
        explanation: "Preventive healthcare focuses on preventing diseases through vaccinations, health education, and lifestyle changes."
      },
      {
        question: "How do mobile clinics benefit rural communities?",
        options: [
          "Bring services closer to people",
          "Replace all local health workers",
          "Provide only specialized care",
          "Focus only on children"
        ],
        correctAnswer: 0,
        explanation: "Mobile clinics extend healthcare services to remote areas, reducing travel time and costs for rural populations."
      },
      {
        question: "What is integrated healthcare?",
        options: [
          "Combining traditional and modern medicine",
          "Using only traditional methods",
          "Relying only on modern medicine",
          "Importing all medical supplies"
        ],
        correctAnswer: 0,
        explanation: "Integrated healthcare combines the strengths of traditional and modern medicine for comprehensive patient care."
      },
      {
        question: "Why is there stigma around mental health in some communities?",
        options: [
          "Lack of understanding and cultural beliefs",
          "Too much information",
          "Over-treatment",
          "Government policies"
        ],
        correctAnswer: 0,
        explanation: "Stigma often arises from lack of understanding, cultural beliefs, and misconceptions about mental health conditions."
      },
      {
        question: "What are community health workers trained to do?",
        options: [
          "Provide basic care and health education",
          "Perform complex surgeries",
          "Manage hospitals",
          "Import medicines"
        ],
        correctAnswer: 0,
        explanation: "Community health workers are trained to provide basic healthcare services, health education, and referrals to facilities."
      },
      {
        question: "How can technology improve healthcare in Africa?",
        options: [
          "Through telemedicine and health apps",
          "By replacing all health workers",
          "Through expensive equipment only",
          "By eliminating traditional medicine"
        ],
        correctAnswer: 0,
        explanation: "Technology like telemedicine, mobile health apps, and electronic records can improve access and efficiency in healthcare."
      },
      {
        question: "What is holistic health?",
        options: [
          "Addressing physical, mental, and social well-being",
          "Focusing only on physical symptoms",
          "Using only natural remedies",
          "Ignoring preventive care"
        ],
        correctAnswer: 0,
        explanation: "Holistic health considers the whole person - physical, mental, emotional, and social aspects - in healthcare."
      },
      {
        question: "Why are maternal and child health important indicators?",
        options: [
          "They reflect overall health system strength",
          "They only affect women",
          "They are easy to measure",
          "They don't reflect community health"
        ],
        correctAnswer: 0,
        explanation: "Maternal and child health outcomes are key indicators of healthcare system effectiveness and overall community well-being."
      }
    ]
  }
  // Additional courses would continue here with the same structure...
];

// For demonstration, we'll use 3 complete courses. You can expand to 17 following the same pattern.